import { useEffect } from 'react';
import {
    WhatsappShareButton,
    WhatsappIcon,
} from 'next-share';

export const WhatsappShareTemplate = ({ pageUrl, pageTitle }) => {
    useEffect(() => {
        // Add `rel="nofollow"` to the first anchor tag in this component
        const shareLinks = document.querySelectorAll('.whatsapp-share-button button');
        shareLinks.forEach((link) => {
            link.setAttribute('rel', 'nofollow');
        });
    }, []);
    return (
        <div className="whatsapp-share-button">
            <WhatsappShareButton
                url={`${pageUrl}`}
                title={`${pageTitle}`}
                separator=":: "
            >
                <WhatsappIcon size={44} round />
            </WhatsappShareButton>
        </div>
    );
}
